import "font-awesome/css/font-awesome.min.css";
import Loader from "./Loader";
import "../../src/App.css";
import "../styles/generator.css";
import { getDownPayModalObject, getCompareModalObject, getAssessmentObject } from "../js/helper";
import Calculations from './Calculations';
import LoanSummaryDetails from './child/LoanSummaryDetails'
import InstallmentTerms from './child/InstallmentTerms'
import CompareScreen from './child/compare/CompareScreen'
import DownPayment from './child/Modal/DownPayment'
import Assessment from './child/Modal/Assessment'
import { ItemsList, FooterButtons } from './child/MainScreenComponents'
import { SidebarLayout } from "./SidebarLayout";

export const Welcome = () => {
  const state = {
    pageSource: "qr",
    merchantStore: JSON.parse(sessionStorage.getItem("merchantStore")),
    RBPObject: JSON.parse(sessionStorage.getItem("RBPObject")),
    promoterDetails: JSON.parse(sessionStorage.getItem("promoterDetails")),
    selectedValue: sessionStorage.getItem("merchantId"),
    userDetails: JSON.parse(sessionStorage.getItem("userDetails")),
  };

  const logic = Calculations(state);

  return (
    <>
      <Assessment {...getAssessmentObject(logic)} />
      <DownPayment {...getDownPayModalObject(logic)} />
      {logic.showCompare && <CompareScreen {...getCompareModalObject(logic)} />}

      <div className="generator-page d-flex">
        <SidebarLayout sideNavPosition={1}>
          {logic.isLoading && <Loader />}

          <div className="page-title">QR Generator</div>
          <ItemsList logic={logic} />
          <LoanSummaryDetails {...logic} />
          <InstallmentTerms {...logic} />

          {FooterButtons(
            state,
            logic.assesmentPopupShow,
            logic.disableButton,
            logic.isValidQR,
            logic.applicationType,
            logic.silComProduct,
            logic.selectedCompetitors,
            // pageSource="qr"
          )}
        </SidebarLayout>
      </div>
    </>
  );
};

export default Welcome;